export const data = [
    {
        id: 1,
        projectName: "Geckodriver buildpack",
        repositoryStatus: {
            forks: "26",
            clones: "54",
            stars: "20",
            issues: "6",
            "pull requests": "2"
        }
    }
]